export const REGISTER_ISLAND_ID = 'register-island'
